import { useEffect, useRef } from 'react';
import axios from 'axios';

/**
 * Hook to track when a puzzle is opened
 * Call this from each puzzle component with the puzzle name
 */
export const usePuzzleTracking = (puzzleName: string) => {
  const trackedRef = useRef(false);

  useEffect(() => {
    // Only track once per mount
    if (trackedRef.current) return;
    trackedRef.current = true;

    // Track puzzle open (fire and forget)
    axios.post('/api/analytics/track-puzzle-open', { puzzleName })
      .catch(err => {
        // Fail silently - analytics shouldn't break the app
        console.debug('Analytics tracking failed:', err);
      });
  }, [puzzleName]);
};
